<template>
    <ul class="pagination" >
        <li :disabled="pageData.pageNo == 1" @click="prePage()" ><a href="javascript:;">上一页</a></li>
        <li v-for="index in pages" @click="toPage(index)" :class="{'active':pageData.pageNo == index}" :key="index">
          <a href="javascript:;" >{{index}}</a>
        </li>
        <li :disabled="pageData.totalPage == pageData.pageNo || (pageData.totalPage <= 1) " @click="nextPage()"><a href="javascript:;" >下一页</a></li>
        <li><a>共{{pageData.totalPage}}页</a></li>

    </ul>
</template>

<script type="es6">
    import { mapState, mapActions, mapGetters } from 'vuex'
    import { util } from '../service/util'
    export default {
        name:'sd-pager',
        props: ['pageData'],
        data () {
            return {
                showItem:5,
            }
        },
        computed: {
            pages(){
                var pag = [];
                  if( this.pageData.pageNo < this.showItem ){
                       var i = Math.min(this.showItem,this.pageData.totalPage);
                       while(i){
                           pag.unshift(i--);
                       }
                   } else {
                       var middle = this.pageData.pageNo - Math.floor(this.showItem / 2 ),//从哪里开始
                           i = this.showItem;
                       if( middle >  (this.pageData.totalPage - this.showItem)  ){
                           middle = (this.pageData.totalPage - this.showItem) + 1
                       }
                       while(i--){
                           pag.push( middle++ );
                       }
                   }
                 return pag
               }
        },
        methods: {
            // 上一页
            prePage() {
              this.pageData.pageNo-- && this.toPage(this.pageData.pageNo--);
            },
            // 下一页
            nextPage() {
              this.pageData.pageNo++ && this.toPage(this.pageData.pageNo++)

            },
            toPage(index) {

                if(index == this.pageData.pageNo){
                    return;
                }
                this.pageData.pageNo = index;
                this.$emit('page-change',index);
            }
        },

    }
</script>

<style lang="scss">
  .pagination {
    position: relative;
    display: inline-block;
  }
  .pagination li{
    display: inline-block;
    margin:0 5px;
  }
  .pagination li a{
    padding: 4px 9px;
    display:inline-block;
    border:1px solid #ddd;
    background:#fff;
    color:#0E90D2;
  }
  .pagination li a:hover{
    background:#eee;
  }
  .pagination li.active a{
    background:#fa0;
    color:#fff;
  }
  li[disabled=disabled] {
    pointer-events: none;
  }
  li[disabled=disabled] a {
    color: #b1b0b0 !important;
    cursor: not-allowed !important;
  }
</style>



// WEBPACK FOOTER //
// sdPager.vue?4e9d69f9